import React, { useState, useMemo } from 'react';
import { Pivot } from 'api';
import loginImg from 'asset/image/img_login@2x.png';
import { useDispatch } from 'react-redux';
import { Button, Form } from 'antd';
import styles from './index.module.scss';
import ModifyPassword from 'lib/publicUsecase/ModifyPassword';
import { ModifyPasswordResStatus } from 'lib/publicUsecase/type';
import APP_ROUTE from 'constant/route';
import { useHistory } from 'react-router';
import { noop } from 'lodash';
import WithPrivateCheck from 'component/WithPrivateCheck';
import ModifySuccess from './ModifySuccess';
import { appMessageError } from 'model/app';
import LoginMobileCaptchaItem from 'component/AuthForm/LoginMobileCaptchaItem';
import LoginMobileItem from 'component/AuthForm/LoginMobileItem';
import LoginPasswordItem from 'component/AuthForm/LoginPasswordItem';
import { getSessionId } from 'util/session';
import MobileCaptcha from 'lib/publicUsecase/MobileCaptcha';
import { useStore } from 'page/Login/component/useStore';
import { useCountDown } from 'util/countdown';

interface IProps {
  // 是否显示验证码提示错误
  displayCodeHelper: boolean;
  disabledVerifyCode?: boolean;
  displayCodeTimeOut?: boolean;
  onSendVerifyCode: (mobile: string) => void;
}

interface FormData {
  mobile: string;
  password: string;
  confirmPassword: string;
  mobileCaptcha: string;
}

const ForgotPassword: React.FC<IProps> = () => {
  const [form] = Form.useForm<FormData>();
  const dispatch = useDispatch();
  const history = useHistory();
  const { countDown, isDisposed, startCountDown } = useCountDown();
  const { formStore, stateStore, stateData, formData, handleFromDataChange, handleStateDataChange } = useStore<FormData>(
    {
      mobile: '',
      mobileCaptcha: '',
      password: '',
      confirmPassword: ''
    },
    {
      modifyLoading: false,
      mobileCaptchaeLoading: false,
      mobileCaptchaeError: '',
      mobileError: '',
      passwordError: ''
    }
  );

  const [successData, setSuccessData] = useState();

  function onFieldsChange() {
    const newData = form.getFieldsValue();
    handleFromDataChange(newData);
  }

  const modifyPassword = new ModifyPassword({
    API: {
      getSessionId,
      modifyPassword: (data: any) => Pivot.modifyPassword(data).toPromise()
    },
    formStore: formStore as any,
    stateStore
  });

  const mobileCaptchaInstance = new MobileCaptcha({
    API: {
      startCountDown,
      getMobileCaptcha: (mobile, type, slidingCaptcha) => Pivot.getMobileCaptchas(mobile, type, slidingCaptcha).toPromise()
    },
    state: stateStore
  });

  async function handleSumbit() {
    const formRes = await form.validateFields().catch(noop);
    console.log('formRes', formRes);

    if (!formRes) return;
    try {
      const res = await modifyPassword.fetchModifyPassword();
      if (!res) return;
      const { status, data } = res;
      if (status === ModifyPasswordResStatus.SUCCESS) {
        // 设置密码成功
        setSuccessData(data);
      } else if (status === ModifyPasswordResStatus.SAME_IN_HISTORY) {
        // 设置密码失败，错误原因不能与上一次密码相同
        dispatch(appMessageError('设置密码失败，错误原因不能与上一次密码相同'));
      } else if (status === ModifyPasswordResStatus.CAPTCHA_ERROR) {
        // 短信验证码错误
        dispatch(appMessageError('短信验证码错误'));
      } else if (status === ModifyPasswordResStatus.MOBILE_NOT_EXISTS) {
        // 账号未注册
      } else if (status === ModifyPasswordResStatus.CAPTCHA_BUSY) {
        dispatch(appMessageError('验证码错误次数过多，请稍后重试'));
      }
    } catch (error) {
      console.log('handleSumbit error', error);
      dispatch(appMessageError('设置密码失败，请稍后再试'));
    }
  }

  const onClickVerifyCode = (slidingCaptcha: any) => {
    const mobile = form.getFieldValue('mobile');
    mobileCaptchaInstance.getMobileCaptcha(mobile, 3, slidingCaptcha);
  };

  const handleCancel = () => {
    history.replace(APP_ROUTE.LOGIN);
  };

  const handlePhoneChange = () => {
    handleStateDataChange({ mobileCaptchaeError: '' });
  };

  const { mobile, password, mobileCaptcha, confirmPassword } = form.getFieldsValue();

  const submitBtnEnable = useMemo(() => {
    return mobile && password && mobileCaptcha && confirmPassword;
  }, [mobile, password, mobileCaptcha, confirmPassword]);

  // eslint-disable-next-line multiline-ternary
  return (
    <div className={styles.wrapper}>
      <div className={styles.content}>
        <div className={styles.banner}>
          <img src={loginImg} />
        </div>
        <div className={styles.loginContainer}>
          <div className={styles.title}>
            MAXHUB 会议预约系统{' '}
            <WithPrivateCheck>
              <div className={styles.priv_title}>- 本地部署 -</div>
            </WithPrivateCheck>
          </div>
          <div className={styles.main}>
            {
              // eslint-disable-next-line multiline-ternary
              successData ? (
                <ModifySuccess mobile={formStore.value.mobile} loginData={successData} />
              ) : (
                <div>
                  <div className={styles.mainTitleContainer}>
                    <div className={styles.mainTitle}>忘记密码</div>
                  </div>
                  <div className={styles.formWrapper}>
                    {/* <LoginLoading status={loginStatus} /> */}
                    <Form form={form} onFieldsChange={onFieldsChange} initialValues={formStore.value}>
                      {/* 手机号 */}
                      <LoginMobileItem name="mobile" onChange={handlePhoneChange} />
                      {stateData.mobileError && (
                        <div className={styles['custome-error']}>
                          账号未注册，<span onClick={handleCancel}>立即注册</span>
                        </div>
                      )}
                      {/* 手机号 end */}
                      <LoginMobileCaptchaItem
                        name="mobileCaptcha"
                        onChange={() => {
                          handleStateDataChange({ mobileCaptchaeError: '' });
                        }}
                        help={stateData.mobileCaptchaeError}
                        loading={stateData.mobileCaptchaeLoading}
                        disabled={!formData.mobile}
                        countDown={countDown}
                        isDisposed={isDisposed}
                        form={form}
                        targetValication={'mobile'}
                        onClick={onClickVerifyCode}
                      />
                      {/* 密码 */}
                      <LoginPasswordItem type="new" name="password" help={stateData.passwordError} />
                      <LoginPasswordItem type="confirm" name="confirmPassword" />
                      <div className={styles.buttonWrapper}>
                        <Button className={styles.buttonCancel} disabled={stateData.modifyLoading} size="large" onClick={handleCancel}>
                          取消
                        </Button>
                        <Button
                          className={styles.buttonSubmit}
                          loading={stateData.modifyLoading}
                          disabled={!submitBtnEnable}
                          type="primary"
                          size="large"
                          htmlType="submit"
                          onClick={handleSumbit}
                        >
                          确定
                        </Button>
                      </div>
                    </Form>
                  </div>
                </div>
              )
            }
          </div>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
